/**
 * Ho-SYS — Food Waste Module API client
 */
import { getMemToken } from "@/api/api";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

async function req(path, opts = {}) {
  const url = `${API_URL}${path}`;
  const headers = { "Content-Type": "application/json", ...(opts.headers || {}) };
  const t = getMemToken();
  if (t) headers["Authorization"] = `Bearer ${t}`;
  const res = await fetch(url, { ...opts, credentials: "include", headers });
  if (!res.ok) {
    let detail = "Error";
    try {
      const j = await res.json();
      detail = j.detail || JSON.stringify(j);
    } catch (e) { /* noop */ }
    throw new Error(detail);
  }
  return res.json();
}

function qs(params) {
  const usp = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    usp.append(k, v);
  });
  const s = usp.toString();
  return s ? `?${s}` : "";
}

export const wasteApi = {
  // settings
  getSettings: (venue_id) => req(`/api/waste/settings${qs({ venue_id })}`),
  updateSettings: (data) =>
    req(`/api/waste/settings`, { method: "PUT", body: JSON.stringify(data) }),

  // records
  listRecords: (params) => req(`/api/waste/records${qs(params)}`),
  createRecord: (data) =>
    req(`/api/waste/records`, { method: "POST", body: JSON.stringify(data) }),
  updateRecord: (id, data) =>
    req(`/api/waste/records/${id}`, { method: "PATCH", body: JSON.stringify(data) }),
  deleteRecord: (id) =>
    req(`/api/waste/records/${id}`, { method: "DELETE" }),

  // kpis & critical
  getKpis: (venue_id, days = 30) =>
    req(`/api/waste/kpis${qs({ venue_id, days })}`),
  getCriticalProducts: (venue_id, days = 30) =>
    req(`/api/waste/critical-products${qs({ venue_id, days })}`),

  // reuse
  listReuse: (venue_id) => req(`/api/waste/reuse${qs({ venue_id })}`),
  createReuse: (data) =>
    req(`/api/waste/reuse`, { method: "POST", body: JSON.stringify(data) }),
  updateReuse: (id, data) =>
    req(`/api/waste/reuse/${id}`, { method: "PATCH", body: JSON.stringify(data) }),
  deleteReuse: (id) =>
    req(`/api/waste/reuse/${id}`, { method: "DELETE" }),

  // alerts
  listAlerts: (venue_id, status = "active") =>
    req(`/api/waste/alerts${qs({ venue_id, status })}`),
  acknowledgeAlert: (id) =>
    req(`/api/waste/alerts/${id}/acknowledge`, { method: "POST" }),

  // suggestions
  productSuggestions: (venue_id, q = "") =>
    req(`/api/waste/product-suggestions${qs({ venue_id, q })}`),
};

export default wasteApi;
